module.exports = __webpack_public_path__ + "img/rounded.bbf2f7f2.png";